import React from 'react'

import Navigation from '../components/navigation/Navigation'

interface Props {
    role: String
};
interface State {
    error: String | null,
    isLoading: Boolean
};

export default class NotFoundPage extends React.Component<Props, State>
{
    constructor(props: Props) 
    {
        super(props)
        
        this.state = {
            error: null,
            isLoading: false
        }
    }

    componentDidCatch(error:any, info:any) {
        //window.location.href = `/error?source=${window.location.pathname}`;
    }

    render() {
        const { error, isLoading } = this.state

        const params = new URLSearchParams(window.location.search);
        const source = params.get('source');
        
        return (
            <div className="render-home">
                <Navigation role={this.props.role}/>
                <div className="container">
                    <div style={{fontSize:'5rem', color: '#2D2D2D', fontWeight: 'bold',width: '100%', textAlign:'center', padding:'2rem'}}>
                        Något gick fel... :(
                    </div>
                    {
                        source != null ?
                            <div style={{textAlign:'center', color:'#2D2D2D', fontSize:'1.5rem'}}>Ladda om <a href={source}>sidan</a></div>
                        :
                            <div style={{textAlign:'center', color:'#2D2D2D', fontSize:'1.5rem'}}>Börja om från <a href='/'>startsidan</a></div>
                    }
                </div>
            </div>
        )
    }
}
